// src/pages/PatientRegistration.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../components/CustomButton';
import { Link } from 'react-router-dom';

export default function PatientRegistration() {
  const navigate = useNavigate();

  return (
    <>
      <div style={{ minHeight: '100vh', background: '#f4f4f4' }}>
        <div
          style={{
            maxWidth: '960px',
            margin: '0 auto',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          {/* ← 患者一覧に戻る */}
          <div style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
            <Link
              to="/patient-selection"
              className="sidebar-link"
              style={{ textDecoration: 'none', color: '#0062ff', fontWeight: 'bold' }}
            >
              ← 患者一覧に戻る
            </Link>
          </div>
          <h2 style={{ margin: '1rem' }}>患者登録方法の選択</h2>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '2rem',
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            <CustomButton
              kind="primary"
              className="btn-wide"
              onClick={() => navigate('/patient-registration/manual')}
            >
              手動登録
            </CustomButton>

            <CustomButton
              kind="primary"
              className="btn-wide"
              onClick={() => navigate('/patient-registration/upload')}
            >
              ファイル登録
            </CustomButton>
          </div>
        </div>
      </div>
    </>
  );
}
